import React, { type PropsWithChildren } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useGetMeQuery } from '../../../store/user/user'
import { type IntegrationServiceId } from '../../../common/integrations'
import { useIntegrations } from '../../Integration/useIntegrations'
import { ConnectIntegrationButton, ReconnectIntegrationButton } from './IntegrationConnectionButtons'
import { isIntegrationConnected, isIntegrationInvalidated } from './utils'

interface IntegrationUserActionProps {
  serviceId: IntegrationServiceId
  isSupported: boolean
  onConnectionClick: (button: 'connect' | 'reconnect') => void
}

export const IntegrationUserAction: React.FC<PropsWithChildren<IntegrationUserActionProps>> = ({ serviceId, isSupported, onConnectionClick, children }) => {
  const accountId = useAppSelector(selectAccountId)

  const { data: currentUser, isFetching: isCurrentUserFetching } = useGetMeQuery({ accountId }, { refetchOnMountOrArgChange: true })
  const { isIntegrationAllowed, isLoading: isIntegrationsLoading } = useIntegrations()

  if (!currentUser || isCurrentUserFetching || isIntegrationsLoading || !isSupported || !isIntegrationAllowed(serviceId)) {
    return null
  }

  const handleReconnectClick = () => {
    onConnectionClick('reconnect')
  }

  const handleConnectClick = () => {
    onConnectionClick('connect')
  }

  if (isIntegrationInvalidated(currentUser, serviceId)) {
    return <ReconnectIntegrationButton serviceId={serviceId} onClick={handleReconnectClick} />
  }

  if (!isIntegrationConnected(currentUser, serviceId)) {
    return <ConnectIntegrationButton serviceId={serviceId} onClick={handleConnectClick} />
  }

  return <>{children}</>
}
